import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from "prop-types";
import {Scrollbars} from 'react-custom-scrollbars';
import Framework from '@beardeddevops/react.framework';
import Lockable from "components/Lockable";
import Access from "constants/Access";

class SidebarContent extends Lockable {

	static propTypes = {
		locations: PropTypes.array,
		//clickOutsideHandler: PropTypes.func.isRequired,
	};

	componentDidMount() {
		const {history} = this.props;
		const nav = this.nav;
	}

	handleRef = (ref) => this.nav = ref

	render() {
		const {rootState, clickOutsideHandler, history} = this.props;
		const {userAccess, hasPawnModule, hasNFAModule, hasManufacturingModule, hasImporterModule, hasDavidsonsModule,
			hasAutoAcquisitionModule, account_number, hasAmmoreadyModule, hasGunbrokerModule, hasCustomExportsModule} = rootState;
		/** @type {Array.<Locations_Object>} locations */
		const locations = rootState.locations;
		const acc880 = account_number === 880;
		return (
			<>
				<Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/dashboard'}
					parentId={'dashboard'}
					parentIcon={'tachometer'}
					parentLinkText={'Dashboard'}
					history={history}
					path={history.location.pathname}
					default={'open'}
				/>
				{userAccess <= Access.Manager &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/point_of_sales'}
						parentId={'point_of_sales'}
						parentIcon={'credit-card-alt'}
						parentLinkText={'Point of Sale'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>}
				{userAccess <= Access.Supervisor &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/accounts/market_place'}
						parentId={'marketplace'}
						parentIcon={'files-o'}
						parentLinkText={'Marketplace'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>}
				{userAccess <= Access.Supervisor && !hasAutoAcquisitionModule &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/acquisitions'}
						parentId={'acquisitions'}
						parentIcon={'download'}
						parentLinkText={'Acquisitions'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					>
						{hasPawnModule &&
							<li>
								<Link data-id={'pawns'} variant={"text"} to="/acquisitions/pawns">
									<i className="fa fa-usd"/>
									<span className="nav-text">Pawn Dashboard</span>
								</Link>
							</li> }
						{hasImporterModule &&
							<li>
								<Link data-id={'imports'} variant={"text"} to="/acquisitions/imports">
									<i className="fa fa-arrow-circle-o-down"/>
									<span className="nav-text">Imports</span>
								</Link>
							</li>
						}
						<li>
							<Link data-id={'acquisitions/pendings'} variant={"text"} to="/acquisitions/pendings">
								<i className="fa fa-hourglass"/>
								<span className="nav-text">In-Network Transfers</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>}
				<Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/dispositions'}
					parentId={'dispositions'}
					parentIcon={'upload'}
					parentLinkText={'Dispositions'}
					history={history}
					path={history.location.pathname}
					default={'open'}
				>
					{ !this.props.rootState.all_locations_expired &&
						<li>
							<a color={'none'} onClick={() => this.handleSetPin(1)}>
								<i className="fa fa-lock"/>
								<span className="nav-text">Kiosk Mode</span>
							</a>
						</li>
					}
						<li>
							<Link data-id={'one_page'} variant={"text"} to="/dispositions/one_page">
								<i className="fa fa-file-pdf-o"/>
								<span className="nav-text">Start 4473</span>
							</Link>
						</li>
						<li>
							<Link data-id={'dispositions/pendings'} variant={"text"} to="/dispositions/pendings">
								<i className="fa fa-ellipsis-h"/>
								<span className="nav-text">Pending 4473s</span>
							</Link>
						</li>
						<li>
							<a target={'_blank'} href={'https://www.cjis.gov/'}>
								<i className="fa fa-check-square-o"/>
								<span className="nav-text">NICS Status</span>
							</a>
						</li>
						<li>
							<Link data-id={'multiple_sales'} variant={"text"} to="/dispositions/multiple_sales">
								<i className="fa fa-clone"/>
								<span className="nav-text">Multiple Sales</span>
							</Link>
						</li>
						<li>
							<Link data-id={'cancels'} variant={"text"} to="/dispositions/cancels">
								<i className="fa fa-ban"/>
								<span className="nav-text">Cancelled / Denied</span>
							</Link>
						</li>
				</Framework.Elements.NavGroup>

				<Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/products'}
					parentId={'products'}
					parentIcon={'barcode'}
					parentLinkText={'Products / Firearms'}
					history={history}
					path={history.location.pathname}
					default={'open'}
				>
					<li>
						<Link data-id={'inventories'} variant={"text"} to="/products/inventories">
							<i className="fa fa-list-ul"/>
							<span className="nav-text">Inventory Count</span>
						</Link>
					</li>
					<li>
						<Link data-id={'upc_center'} variant={"text"} to="/products/upc_center">
							<i className="fa fa-list-ul"/>
							<span className="nav-text">UPC Center</span>
						</Link>
					</li>
					<li>
						<Link data-id={'ioi_inspections'} variant={"text"} to="/products/ioi_inspections">
							<i className="fa fa-id-badge"/>
							<span className="nav-text">IOI Inspections</span>
						</Link>
					</li>
					{hasManufacturingModule && <li>
						<Link data-id={'manufactureds'} variant={"text"} to="/products/manufactureds">
							<i className="fa fa-wrench"/>
							<span className="nav-text">Firearm Manufacture</span>
						</Link>
					</li>
					}
					{acc880 &&
						<li>
							<Link data-id={'product_buyers'} variant={"text"} to="/products/product_buyers">
								<i className="fa fa-shopping-bag"/>
								<span className="nav-text">Product Buyers</span>
							</Link>
						</li>
					}
					{hasAmmoreadyModule &&
						<li>
							<Link data-id={'ammoready_products'} variant={"text"} to="/products#ammoready_products">
								<i className="fa fa-shopping-bag"/>
								<span className="nav-text">AmmoReady Products</span>
							</Link>
						</li>}
					{hasGunbrokerModule &&
						<li>
							<Link data-id={'gunbroker_products'} variant={"text"} to="/products#foreign">
								<i className="fa fa-shopping-bag"/>
								<span className="nav-text">GunBroker Products</span>
							</Link>
						</li>}
				</Framework.Elements.NavGroup>
				{hasCustomExportsModule &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/custom_exports'}
						parentId={'custom_exports'}
						parentIcon={'shopping-bag'}
						parentLinkText={'Custom Exports'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>}
				{hasDavidsonsModule &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/davidsons_products'}
						parentId={'davidsons_products'}
						parentIcon={'shopping-bag'}
						parentLinkText={'Davidsons Products'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>}
				<Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/customers'}
					parentId={'customers'}
					parentIcon={'users'}
					parentLinkText={'My Customers'}
					history={history}
					path={history.location.pathname}
					default={'open'}
				>
						<li>
							<Link data-id={'nics_denies'} variant={"text"} to="/customers/nics_denies">
								<i className="fa fa-window-close-o"/>
								<span className="nav-text">NICS Denied</span>
							</Link>
						</li>
				</Framework.Elements.NavGroup>
				<Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/dealers'}
					parentId={'dealers'}
					parentIcon={'suitcase'}
					parentLinkText={'My FFL Dealers'}
					history={history}
					path={history.location.pathname}
					default={'open'}
				>
					{userAccess <= Access.Supervisor ?
						<li>
							<Link data-id={'transfers'} variant={"text"} to="/transfers">
								<i className="fa fa-random"/>
								<span className="nav-text">Transfers to FFLs</span>
							</Link>
						</li> : null}
				</Framework.Elements.NavGroup>

				{hasImporterModule &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/importers'}
						parentId={'importers'}
						parentIcon={'train'}
						parentLinkText={'My Importers'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>
				}
				{userAccess <= Access.Manager &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/destroys'}
						parentId={'destroys'}
						parentIcon={'times'}
						parentLinkText={'Destroyed Items'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>
				}
				{userAccess <= Access.Manager &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/losses'}
						parentId={'losses'}
						parentIcon={'question'}
						parentLinkText={'Lost / Stolen'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					/>
				}
				{userAccess <= Access.Manager && (hasNFAModule || hasManufacturingModule) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/nfa'}
						parentId={'nfa'}
						parentIcon={'archive'}
						parentLinkText={'NFA Dashboard'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					>
						<li>
							<Link data-id={'reservations'} variant={"text"} to="/reservations">
								<i className="fa fa-calendar-check-o"/>
								<span className="nav-text">Reservations</span>
							</Link>
						</li>
						<li>
							<Link data-id={'rentals'} variant={"text"} to="/rentals">
								<i className="fa fa-tags"/>
								<span className="nav-text">Rentals</span>
							</Link>
						</li>
						<li>
							<Link data-id={'exports'} variant={"text"} to="/exports">
								<i className="fa fa-globe"/>
								<span className="nav-text">Exports</span>
							</Link>
						</li>
						<li>
							<Link data-id={'legal_entities'} variant={"text"} to="/legal_entities">
								<i className="fa fa-handshake-o"/>
								<span className="nav-text">Trusts & Legal Entities</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}
				<Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/events'}
					parentId={'events'}
					parentIcon={'calendar'}
					parentLinkText={'Events / Gun Shows'}
					history={history}
					path={history.location.pathname}
					default={'open'}
				/>
				{userAccess <= Access.Manager &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/changes'}
						parentId={'changes'}
						parentIcon={'user'}
						parentLinkText={'Employee Monitor'}
						history={history}
						path={history.location.pathname}
						default={'open'}
					>
						<li>
							<Link data-id={'emails'} variant={"text"} to="/changes/emails">
								<i className="fa fa-envelope-o"/>
								<span className="nav-text">Emails Sent</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}
				{userAccess <= Access.Supervisor && <li className={'nav-header'}>
					<span>
						Locations
						<Link style={{float: "right"}} data-id={'locations'} variant={"text"} to="/locations">
							<i className="fa fa-gears"/>
						</Link>
					</span>
				</li>}
				{userAccess <= Access.Supervisor && locations
					.filter(
						/**
						 * @param {Locations_Object} location
						 * @returns {boolean}
						 */
						location => !location.archived)
					.map(
						/**
						 * @param {Locations_Object} location
						 * @param key
						 */
						(location, key) => {
							return (
								<li key={key}>
									<Link className={'location'} data-id={'location-' + location.binary_id + '-' + location.pkey}
									      variant={"text"}
									      to={"/locations/" + location.binary_id + '-' + location.pkey}>
										<i className="fa fa-building"/>
										<span className="nav-text">{location.name_display || location.name}</span>
									</Link>
									<ul style={{display: 'block'}}>
										<li>
											<Link className={'bound-book'}
											      data-id={'primary-bound-book-' + location.binary_id + '-' + location.pkey}
											      variant={"text"}
											      to={"/locations/" + location.binary_id + '-' + location.pkey}>
												<i className="fa fa-book"/>
												<span className="nav-text">{location.bound_book || 'Primary'}</span>
											</Link>
										</li>
										{location.location_bound_bookss.map((bound_book, key) => {
											/** @type {Locations_Bound_Books_Object} bound_book */
											return (
												<li key={key}>
													<Link
														data-id={'bound-book-' + location.binary_id + '-' + location.pkey + '/' + bound_book.binary_id + '-' + bound_book.pkey}
														variant={"text"}
														to={"/locations/" + location.binary_id + '-' + location.pkey + '/' + bound_book.binary_id + '-' + bound_book.pkey}>
														<i className="fa fa-book"/>
														<span className="nav-text">{bound_book.name}</span>
													</Link>
												</li>
											)
										})}
									</ul>
								</li>
							)
						}
					)
				}
			</>
		);
	}
}

export default Framework.Components.withRootState(withRouter(SidebarContent));
